import { render, staticRenderFns } from "./courseName.vue?vue&type=template&id=7ebec578&scoped=true&"
import script from "./courseName.vue?vue&type=script&lang=js&"
export * from "./courseName.vue?vue&type=script&lang=js&"
import style0 from "./courseName.vue?vue&type=style&index=0&id=7ebec578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebec578",
  null
  
)

export default component.exports